import React from 'react';
import { Typography, Grid, Divider, Box } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import {
    AboutContainer,
    AboutImage,
    ContactChip,
    ContactChipsContainer,
} from './About.styles';

const About = () => {
    return (
        <Box sx={{ py: { xs: 8, md: 12 } }}>
            <AboutContainer id="about">
                <Grid container spacing={6} alignItems="center">
                    <Grid item xs={12} md={5}>
                        <AboutImage
                            src={'assets/aboutArt.webp'}
                            alt="Done Right Home Services Logo"
                        />
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <Typography
                            variant="h4"
                            component="h2"
                            gutterBottom
                            color="text.primary"
                            sx={{
                                fontWeight: 600,
                                fontSize: { xs: '1.75rem', md: '2.125rem' },
                                mb: 2,
                                textAlign: { xs: 'center', md: 'left' },
                            }}
                        >
                            About Done Right Home Services
                        </Typography>
                        <Divider sx={{ mb: 3 }} />

                        <Typography
                            variant="body1"
                            paragraph
                            color="text.secondary"
                            sx={{
                                fontSize: { xs: '1rem', md: '1.2rem' },
                                lineHeight: '1.6',
                                fontWeight: 500,
                                textAlign: { xs: 'center', md: 'left' },
                            }}
                        >
                            I've been in and around construction most of my life
                            in one fashion or the other. Although my early
                            career was spent in the computer industry managing
                            data centers, I've always been a do-it-yourself guy
                            who liked working with my hands.
                        </Typography>
                        <Typography
                            variant="body1"
                            paragraph
                            color="text.secondary"
                            sx={{
                                fontSize: { xs: '1rem', md: '1.2rem' },
                                lineHeight: '1.6',
                                fontWeight: 500,
                                textAlign: { xs: 'center', md: 'left' },
                            }}
                        >
                            So, after moving to Central Oregon in 2013 following
                            a stint of working in the airline industry I was
                            looking for a new challenge. At that time the
                            building industry was booming, and I noticed a need
                            for qualified individuals to do new construction
                            cleaning.
                        </Typography>
                        <Typography
                            variant="body1"
                            paragraph
                            color="text.secondary"
                            sx={{
                                fontSize: { xs: '1rem', md: '1.2rem' },
                                lineHeight: '1.6',
                                fontWeight: 500,
                                textAlign: { xs: 'center', md: 'left' },
                            }}
                        >
                            So Done Right Home Services was born and has been
                            going strong ever since. The business industry has
                            changed and so have I. I no longer do new
                            construction cleaning and now focus on smaller
                            projects and handyman services. My goal is to keep
                            you happy by providing a solid service at a
                            reasonable price.
                        </Typography>
                        <Typography
                            variant="body1"
                            paragraph
                            color="text.secondary"
                            sx={{
                                fontSize: { xs: '1rem', md: '1.2rem' },
                                lineHeight: '1.6',
                                fontWeight: 500,
                                textAlign: { xs: 'center', md: 'left' },
                            }}
                        >
                            I may not be the cheapest or the fastest but you can
                            count on it being done right.
                        </Typography>

                        <ContactChipsContainer>
                            <ContactChip
                                icon={<PhoneIcon />}
                                label="(503) 851-2701"
                                color="primary"
                                variant="contained"
                                clickable
                                component="a"
                                href="tel:5038512701"
                            />
                            <ContactChip
                                icon={<EmailIcon />}
                                label="mark@dnrighthomeservices.com"
                                color="primary"
                                variant="contained"
                                clickable
                                component="a"
                                href="mailto:mark@dnrighthomeservices.com"
                            />
                        </ContactChipsContainer>
                    </Grid>
                </Grid>
            </AboutContainer>
        </Box>
    );
};

export default About;
